import { Box } from '@chakra-ui/react';
import * as React from 'react';
import { Controller } from 'react-hook-form';

import { BlogImageEdit } from './components/BlogImageEdit';

export const BlogImage: React.FC<{
  originalImage?: { imageId: string; imageProxy: string };
}> = ({ originalImage }) => {
  return (
    <Box w="full">
      <Controller
        name="bannerImage"
        render={({ field: { onChange, value, ref, onBlur } }) => (
          <BlogImageEdit
            originalImage={originalImage}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            ref={ref}
          />
        )}
      />
    </Box>
  );
};
